var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","color":"primary","to":{name:'Dashboard'}}},[_c('v-icon',[_vm._v(" mdi-arrow-left ")]),_vm._v(" Back to dashboard ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }